// Вкладка «Дзвінки» в картці клієнта (етап 2 ТЗ телефонії, 23.10).
// Етап 3: результат розмови можна поставити чи змінити й звідси.
// 30.10: «Подзвонити» на основний телефон клієнта; 31.10: поруч — з якого
// телефону, і змінити.
import React, { useState, useEffect, useCallback } from 'react';
import { useAppData } from '../../contexts/DataContext';
import { useToast } from '../../contexts/ToastContext';
import { apiFetch } from '../../services/api';
import {
  CallIcon, callSummary, fmtWhen, canRate, OutcomeSelect, useOutcomeReasons, saveOutcome, DialButton, MyLine,
} from './callsShared';

export default function CustomerCallsTab({ customerId, phone }) {
  const { subscribeSync } = useAppData();
  const toast = useToast();
  const reasons = useOutcomeReasons();
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!customerId) return;
    try {
      const r = await apiFetch(`/api/telephony?action=calls&filter=all&customerId=${encodeURIComponent(customerId)}`);
      setCalls(r.calls || []);
    } catch { /* ignore */ }
    setLoading(false);
  }, [customerId]);

  useEffect(() => { setLoading(true); load(); }, [load]);
  useEffect(() => (subscribeSync ? subscribeSync('calls', load) : undefined), [subscribeSync, load]);

  const setOutcome = async (c, outcome, reason) => {
    try {
      const updated = await saveOutcome(c.id, outcome, reason);
      setCalls(prev => prev.map(x => (x.id === c.id ? { ...x, ...updated } : x)));
    } catch (err) {
      toast.error(err?.message || 'Не вдалося зберегти');
    }
  };

  const bar = phone ? <div className="calls-dial-bar"><MyLine compact /><DialButton phone={phone} /></div> : null;
  if (loading) return <p className="api-keys-muted">Завантаження…</p>;
  if (!calls.length) return <>{bar}<p className="api-keys-muted">Дзвінків з цим клієнтом ще немає.</p></>;
  return (
    <>
    {bar}
    <ul className="calls-list">
      {calls.map(c => (
        <li key={c.id} className="call-row">
          <CallIcon call={c} />
          <div className="call-main">
            <div className="call-who"><span>{c.direction === 'out' ? 'Вихідний' : 'Вхідний'}</span><span className="call-phone">{c.externalNumber}</span></div>
            <div className="call-meta">{fmtWhen(c.startedAt)} · {callSummary(c)}{c.employeeName ? ` · ${c.employeeName}` : ''}</div>
          </div>
          {canRate(c) && (
            <div className="call-actions">
              <OutcomeSelect call={c} reasons={reasons} onChange={(o, r) => setOutcome(c, o, r)} />
            </div>
          )}
        </li>
      ))}
    </ul>
    </>
  );
}
